import { useState } from 'react';
import FirebaseService from "../../services/firebase/firebase.service";
import { SurveySampleSizes } from 'src/services/firebase/firebase.types';
import { ReactComponent as Star } from "../../assets/icons-redesign/ai-star.svg";
import { ReactComponent as X } from "../../assets/icons-redesign/x.svg";
import AiSampleSize from './ai-sample-size';
// import PulsePolling from './pulse-polling';
import ReactDOM from 'react-dom';

interface CriteriaCardProps {
  extSurveyId: string;
}

const SurveyResponderTrigger = ({ extSurveyId }: CriteriaCardProps) => {
  const config = FirebaseService.getRemoteConfigJSON<SurveySampleSizes>('SAMPLE_SIZES');
  const { human, ai } = config || { human: [], ai: [] };
  const [isOpen, setIsOpen] = useState(false);

  const iconStroke = 'white';
  return (
    <div>
      <button
        className="bg-purple-500 text-white px-3 py-2 h-[40px] rounded-full relative z-50"
        onClick={() => setIsOpen(true)}
      >
        <div className='cursor-pointer flex items-center gap-1.5 text-sm md:text-base font-medium'>
          <Star stroke={iconStroke} />
          AI Panelists
        </div>
      </button>

      {isOpen && (
        ReactDOM.createPortal(
          <>
            <div
              className="md:hidden fixed inset-0 bg-black/20"
              onClick={() => setIsOpen(false)}
            />
            <div
              className="absolute top-48 left-8 md:top-[225px] md:left-[160px] z-50 pointer-events-auto"
            >
              <div className="bg-white rounded-lg shadow-lg w-[330px]">
                <div className="flex justify-end p-2">
                  <button
                    className="bg-gray-300 rounded-full p-1 text-sm hover:bg-gray-400"
                    onClick={() => setIsOpen(false)}
                  >
                    <X
                      width='12px'
                      height='12px'
                      stroke='#4e4e4e'
                    />
                  </button>
                </div>
                <div className="px-4 pb-4">
                  <AiSampleSize
                    extSurveyId={extSurveyId}
                    sampleSizes={ai}
                    zeroDisabled={false}
                    onSubmit={() => setIsOpen(false)}
                  />
                </div>
                {/* <div className="p-4">
                  <PulsePolling
                    extSurveyId={extSurveyId}
                  />
                </div> */}
              </div>
            </div>
          </>,
          document.body
        )
      )}
    </div>
  );
};

export default SurveyResponderTrigger;
